import { Col, Container, Row, Stack } from "react-bootstrap";
import classes from "./styles.module.scss";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLocale } from "@/hooks/useLocale";
import { DynamicText } from "@/ui/DynamicText";
import { useLink } from "@/hooks/useLink";
import Image from "@/ui/Image";

export const AboutPageDiversitySection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <div className={className}>
      <Container>
        <Row className={classes.diversity}>
          <figure className="position-absolute p-0 m-0 w-100 h-100">
            <Image
              img={{ path: "page.about.diversity.image", src: "/assets/about_us/diversity/1.jpg" }}
              size="1300x572"
              className="w-100 h-100"
              alt="diversity"
            />
          </figure>
          <Col xs={12} md={6} className="position-relative p-0">
            <Stack className="flex-md-row p-4 p-md-5">
              <div className="d-flex">
                <DynamicText path={`page.about.diversity.title.${locale}`} tag="h3" className="mb-4 mb-md-0" />
              </div>
              <div>
                <DynamicHtml path={`page.about.diversity.text.${locale}`} style={{ maxWidth: 388 }} />
                <p className="mt-4">
                  <a href={link("about.diversity")}>
                    <DynamicText path={`page.about.diversity.link.${locale}`} />
                  </a>
                </p>
              </div>
            </Stack>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
